import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { InvoicesChargebacksService } from '../../invoices-chargebacks.service';
import { ToastMessageService } from 'src/app/widgets/toast-message/toast-message.service';
import { APInvoice } from '../../accounts-payable-invoice.interface';
import { AP_INVOICE_STATUS_CODES } from 'src/app/constants/ap-invoice-status-codes';
import { Subscription } from 'rxjs';
import { FormService } from 'src/app/services/form.service';

@Component({
  selector: 'app-ap-charge-back-top-bar',
  templateUrl: './ap-charge-back-top-bar.component.html',
  styleUrls: ['./ap-charge-back-top-bar.component.scss']
})
export class ApChargeBackTopBarComponent implements OnInit {

  // claims
  canEdit = this._authSvc.hasClaim('APInvoiceChargebacks', 'Edit');

  // params
  id: any;

  // return link
  returnQueryParams: any;

  // data
  chargeBack = null;
  chargeBackStatusCodes: any;
  subject = 'Charge Back';

  // processing dialog params
  processingTitle: string;
  processingCancellable = false;
  processingDialogIsOpen = false;

  // void
  voidDialogOpen: boolean;
  voidEp: string;
  voidRecordId: number;

  // post confirmation dialog params
  postConfirmDialogOpen = false;
  processingPost = false;

  // subscriptions
  private _printSub: Subscription;

  constructor(
    private _apiSvc: ApiService,
    private _authSvc: AuthService,
    private _formSvc: FormService,
    private _route: ActivatedRoute,
    private _invoicesChargebacksSvc: InvoicesChargebacksService,
    private _toastMsgSvc: ToastMessageService
  ) { }

  ngOnInit() {

    this.id = this._route.snapshot.paramMap.get('id');

    this._invoicesChargebacksSvc.getInvoice(this.id);

    this._invoicesChargebacksSvc.Invoice.subscribe((res: APInvoice) => {
      if (res) {
        this.chargeBack = res;
      }
    });

    const iscs = {};
    AP_INVOICE_STATUS_CODES.forEach((it: any) => {
      iscs[it.value] = it.label;
    });
    this.chargeBackStatusCodes = iscs;

  }

  /**
   * Update query params for return link
   */
  updateReturnQueryParams(qp: any): void {
    if (qp) {
      this.returnQueryParams = qp;
    }
  }

  /**
   * Post invoice
   */
  post(): void {
    this.postConfirmDialogOpen = true;
  }

  /**
   * Post confirmation confirm event handler
   * @param confirm
   */
  onPostConfirm(confirm: any): void {
    this.postConfirmDialogOpen = false;
    if (confirm) {
      this._processPost();
    }
  }

  /**
   * Process posting
   */
  private _processPost(): void {

    // processing dialog params
    this.processingTitle = `${this.subject} posting`;
    this.processingCancellable = false;
    this.processingDialogIsOpen = true;

    this.processingPost = true;

    const ep = `${this._apiSvc.endpoints.monolith}/api/APInvoiceHead/${this.id}/PostInvoice`;
    this._apiSvc.update(ep, {})
      .subscribe(() => {

        this.processingDialogIsOpen = false;

        this._toastMsgSvc.send({
          type: 'success',
          message: `${this.subject} posted`,
          icon: 'check_circle_outline'
        });

        this.processingPost = false;
        this._invoicesChargebacksSvc.getInvoice(this.id);

      }, () => {

        this.processingDialogIsOpen = false;

        this._toastMsgSvc.send({
          type: 'error',
          message: `Unable to post ${this.subject}`,
          icon: 'error_outline'
        });

        this.processingPost = false;

      });

  }

  /**
   * Void action event handler
   * Open void confirmation dialog
   */
  void(): void {
    this.voidEp = `${this._apiSvc.endpoints.monolith}/api/APInvoiceHead/${this.id}/Void`;
    this.voidRecordId = this.id;
    this.voidDialogOpen = true;
  }

  onVoidConfirm(res: any) {
    this.voidDialogOpen = false;
    if (res.confirm) {
      this._invoicesChargebacksSvc.getInvoice(this.id);
    }
  }

  /**
   * Print sales order or delivery ticket
   */
  printDoc(): void {

    const filename = 'ap-charge-back',
      reportEp = `${this._apiSvc.endpoints.reporting}/api/AccountingReporting/chargebackprint`;

    this.processingTitle = `Preparing ${this.subject} print out`;
    this.processingCancellable = true;
    this.processingDialogIsOpen = true;

    const params = {
      APInvoiceHeadId: this.id
    };

    this._printSub = this._apiSvc.getFile(reportEp, params)
      .subscribe((res: any) => {
        this._formSvc.downloadGeneratedPdf(res, filename);
        this.processingDialogIsOpen = false;
      }, () => {
        this.processingDialogIsOpen = false;
        this._toastMsgSvc.send({
            icon: 'error_outline',
            message: 'Unable to generate print out',
            type: 'error'
        });
      });

  }

  /**
   * Cancel request to generate print
   */
  onProcessingCancel(): void {
    this._printSub.unsubscribe();
    this.processingDialogIsOpen = false;
  }

}
